import React from 'react';
import { NextPage } from 'next';
import { useRouter } from 'next/router';
import loadNamespaces from 'next-translate/loadNamespaces';
import { trackActions, commentsActions } from '../../api';

import TrackDetail from '../../containers/TrackDetail/TrackDetail';
import NotFound from '../_error';
import { withAuthSync } from '../../utils/auth';
import { VirpPageContext } from '../_app';

const TrackPage: NextPage<{ trackId?: number }> = () => {
  const router = useRouter();
  const trackId = Number(router.query.trackId);

  if (!trackId) {
    return <NotFound />;
  }

  return <TrackDetail trackId={trackId} />;
};

TrackPage.getInitialProps = async (ctx: VirpPageContext) => {
  const {
    req,
    store,
    query: { trackId: id },
    token,
  } = ctx;
  const getTranslations = await loadNamespaces({
    ...ctx,
    pathname: '/tracks/[trackId]',
  });
  if (!id) return {};

  const trackId = Number(id as string);

  if (req) {
    await Promise.all([
      store?.dispatch(trackActions.fetchTrackById(trackId, false, token)),
      store?.dispatch(trackActions.fetchRelatedTracks(trackId, token)),
      store?.dispatch(commentsActions.fetchComments(trackId, 1)),
    ]);
  }

  return {
    trackId,
    ...getTranslations,
  };
};

export default withAuthSync(TrackPage);
